module.exports = __webpack_public_path__ + "img/file.4f2e9e47.png";